<div [class]="css" [innerHtml]="html | safeHtml" *ngIf="showTemplate"></div>
